import { privateAxios } from 'services/api/privateAxios';
import { adminAPI } from 'services/api/apiUrl';

export const activateDriver = id =>
  privateAxios({
    method: 'post',
    baseURL: adminAPI,
    url: `/driver/activate/${id}`,
  });
